const MAX_COLUMNS = 12;
export const calculateColumnsRelativeToParent = (childCqResponsive, parentCqResponsive = undefined) => {
    var _a;
    return ({
        deviceBreakpoints: (_a = childCqResponsive === null || childCqResponsive === void 0 ? void 0 : childCqResponsive.deviceBreakpoints) === null || _a === void 0 ? void 0 : _a.map(breakpoint => {
            var _a;
            const breakpointWidth = Number(breakpoint.width);
            const parentCqValue = (_a = parentCqResponsive === null || parentCqResponsive === void 0 ? void 0 : parentCqResponsive.deviceBreakpoints) === null || _a === void 0 ? void 0 : _a.find(parentBreakpoint => parentBreakpoint.name === breakpoint.name);
            const parentColumnWidth = Number((parentCqValue === null || parentCqValue === void 0 ? void 0 : parentCqValue.relativeWidth) || (parentCqValue === null || parentCqValue === void 0 ? void 0 : parentCqValue.width) || MAX_COLUMNS);
            if (parentColumnWidth < MAX_COLUMNS && breakpointWidth < MAX_COLUMNS) {
                return Object.assign(Object.assign({}, breakpoint), { relativeWidth: Math.ceil((parentColumnWidth / MAX_COLUMNS) * breakpointWidth).toString() });
            }
            if (parentColumnWidth < MAX_COLUMNS) {
                return Object.assign(Object.assign({}, breakpoint), { relativeWidth: parentColumnWidth.toString() });
            }
            return breakpoint;
        }),
    });
};
//# sourceMappingURL=calculate-columms-relative-to-parent.js.map